import React,{Component} from 'react';
import "./style.less";
import {NavBar,SwipeAction,Toast,Modal} from "antd-mobile";
import {passengerList,deletePassenger} from "../../../service/passengerService";
import {connect} from "react-redux";
const noPassenger = require('../../../common/image/noRider.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class FrequentlyPassenger extends Component{
    constructor(props) {
        super(props);
        this.state = {
            passengerListData:[],
            show: this.props.history.location.datas ? this.props.history.location.datas.type : this.props.history.location.state.type,
            showModal:false,
            passengerId:'',
        };
    }
    componentDidMount(){
        this.getPassenger();
    }
    getPassenger=()=>{
        let params = {
            token: this.props.userInfo.token,
            "data": {
                "pageSize":100,
                "pageNum":1,
                "source":6
            }
        };
        passengerList(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    this.setState({
                        passengerListData:res.data.data.list
                    })
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
    }
    goPage=(res)=>{
        var state = this.props.history.location.datas;
            console.log(res)
            state.returnData({
                name:res.name,
                idNum:res.idNum,
                phone:res.phone,
                idType:res.idType,
            });
        this.props.history.goBack();
       
    }
    delete(id){
        this.setState({
            id:id,
            showModal:true,
        })
    }
    deletePassenger = () =>{
        let params =
        {
            token: this.props.userInfo.token,
            "data": {
                "id":this.state.id,
            }
        }
        deletePassenger(params)
        .then((res) => {
            console.log(res)
            if (res.data.code === '0000') {
                Toast.info('删除成功！',2,this.getPassenger())
            }
            else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
        }).catch(function (error) {
        console.log(error);
    });
    }

    render(){
        return(
            <div className="frequentlyPassenger">
                <NavBar
                    className="navBar"
                    mode="light"
                    rightContent={this.state.show === 1 ? <i className="icon iconfont icontianjiachangyongchengcheren" onClick={() => this.props.history.push('/addfrequentlyPassenger')}></i> : null}
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >{this.state.show === 1 ? "常用乘车人":"选择常用乘车人"}</NavBar>
                <div className="content">
                    {
                        this.state.passengerListData.length > 0 ? (this.state.passengerListData.map((res)=>(
                            <SwipeAction
                            key={res.id}
                            className="listItem"
                            autoClose={true}
                            disabled={this.state.show !==1}
                            right={[
                                {
                                    text:<i className="icon iconfont iconshanchuchengcheren"  />,
                                    onPress: () => {this.delete(res.id)},
                                    style: {backgroundColor: '#F2F3F7',color:'red',width:'80px'},
                                }
                            ]}
                        >
                            <div className="list" onClick={()=>this.state.show == 0 ? this.goPage(res) : null}>
                                <div className="parent">
                                    <div className="left"></div> 
                                    <div className="middle"> 
                                        <div className="name">{res.name}</div>
                                        <div className="ref">手机号：{res.phone}</div>
                                       <p> {res.idType === "passport" ? "护照：" :(res.idType === "idcard" ? "身份证：":"边民证：") }{res.idNum}</p>
                                    </div>
                                </div>
                            </div>
                        </SwipeAction>
                        ))):(
                                <div className="noData">
                                    <img src={noPassenger}/>
                                    <p>常用乘车人是空的？</p>
                                </div>
                            )
                    }
                   
                <Modal
                    className="combineBillViewModal"
                    visible={this.state.showModal}
                    transparent
                    maskClosable={false}
                    footer={[{ text: '取消', onPress: () => { this.setState({showModal:!this.state.showModal}); } },{ text: '确定', onPress: () => { this.setState({showModal:!this.state.showModal});this.deletePassenger() } }]}
                    >
                    <div className="modalTitle">
                        <div>是否确认删除？</div>
                    </div>
                </Modal>

                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/FrequentlyPassenger/index.js